export const isLocal = () => {
  const LOCAL_DOMAINS = ['localhost', '127.0.0.1']
  return LOCAL_DOMAINS.includes(window.location.hostname)
}

export const isCancelMagicsnapPro = () => {
  const CANCEL_MAGICSNAP_DOMAINS = ['cancel.magicsnap.pro']
  return CANCEL_MAGICSNAP_DOMAINS.includes(window.location.hostname)
}

export const isStageMagicsnapPro = () => {
  const STAGE_MAGICSNAP_DOMAINS = ['stage.magicsnap.pro']
  return STAGE_MAGICSNAP_DOMAINS.includes(window.location.hostname)
}

export const isCancelUbodyFit = () => {
  const CANCEL_UBODY_FIT = ['cancel.ubody.fit']
  return CANCEL_UBODY_FIT.includes(window.location.hostname)
}

export const isCancelUbodyKz = () => {
  const CANCEL_UBODY_KZ = ['cancel.ubody.kz']
  return CANCEL_UBODY_KZ.includes(window.location.hostname)
}

export const isCancelUstretchSite = () => {
  const CANCEL_USTRETCH_SITE = ['cancel.ustretch.site']
  return CANCEL_USTRETCH_SITE.includes(window.location.hostname)
}

export const isCancelUbodySite = () => {
  const CANCEL_UBODY_SITE = ['cancel.ubody.site']
  return CANCEL_UBODY_SITE.includes(window.location.hostname)
}

export const isCancelUbodyApp = () => {
  const CANCEL_UBODY_APP = ['cancel.ubody.app']
  return CANCEL_UBODY_APP.includes(window.location.hostname)
}

export const isCancelSelfStretchRu = () => {
  const CANCEL_SELFSTRETCH_RU = ['cancel.selfstretch.ru']
  return CANCEL_SELFSTRETCH_RU.includes(window.location.hostname)
}

export const isCancelUpriseBodyRu = () => {
  const CANCEL_UPRISEBODY_RU = ['cancel.uprisebody.ru']
  return CANCEL_UPRISEBODY_RU.includes(window.location.hostname)
}

export const isCancelUFoodSite = () => {
  const CANCEL_UFOOD_SITE = ['cancel.u-food.site']
  return CANCEL_UFOOD_SITE.includes(window.location.hostname)
}

export const isCancelUtarotInfo = () => {
  const CANCEL_UTAROT_INFO = ['cancel.utarot.info']
  return CANCEL_UTAROT_INFO.includes(window.location.hostname)
}

export const isCancelSelfstretchKz = () => {
  const CANCEL_SELFSTRETCH_KZ = ['cancel.selfstretch.kz']
  return CANCEL_SELFSTRETCH_KZ.includes(window.location.hostname)
}

export const isCancelSingmywishCom = () => {
  const CANCEL_SINGMYWISH_COM = ['cancel.singmywish.com']
  return CANCEL_SINGMYWISH_COM.includes(window.location.hostname)
}

export const isCancelTretcheasyCom = () => {
  const CANCEL_TRECHTEASY_COM = ['cancel.stretchyeasy.com']
  return CANCEL_TRECHTEASY_COM.includes(window.location.hostname)
}

export const isCancelPhotofiltersPro = () => {
  const CANCEL_PHOTOFILTERS_PRO = ['cancel.photofilters.pro']
  return CANCEL_PHOTOFILTERS_PRO.includes(window.location.hostname)
}

export const isCancelTarotinoRu = () => {
  const CANCEL_TAROTINO_RU = ['cancel.tarotino.ru']
  return CANCEL_TAROTINO_RU.includes(window.location.hostname)
}

export const isCancelArtdeepfiltersKz = () => {
  const CANCEL_ARTDEEPFILTERS_KZ = ['cancel.artdeepfilters.kz']
  return CANCEL_ARTDEEPFILTERS_KZ.includes(window.location.hostname)
}

export const isCancelUbundleRu = () => {
  const CANCEL_UBUNDLE_RU = ['cancel.ubundle.ru']
  return CANCEL_UBUNDLE_RU.includes(window.location.hostname)
}

export const isCancelUbodyPro = () => {
  const CANCEL_UBODY_PRO = ['cancel.ubody.pro']
  return CANCEL_UBODY_PRO.includes(window.location.hostname)
}

export const isCancelFadaDateCom = () => {
  const CANCEL_FADA_DATE_COM = ['cancel.fada-date.com']
  return CANCEL_FADA_DATE_COM.includes(window.location.hostname)
}
